import React from "react";
import "../../../styles/SimpleQuizz/ZoneReponses/ZoneReponses.css";
import { AnswerListButtons } from "./AnswerListButtons";
import { ButtonsNextPrevious } from "./ButtonsNextPrevious";
import { BarreProgression } from "./BarreProgression";
export const ZoneReponses = ({
  question,
  questionId,
  setQuestionId,
  userAnswers,
  setUserAnswers,
  numberOfQuestions,
}) => {
  return (
    <aside className="zone_quiz">
      <AnswerListButtons
        question={question}
        questionId={questionId}
        userAnswers={userAnswers}
        setUserAnswers={setUserAnswers}
      />

      <ButtonsNextPrevious
        questionId={questionId}
        setQuestionId={setQuestionId}
        numberOfQuestions={numberOfQuestions}
      />
      <BarreProgression userAnswers={userAnswers} />
    </aside>
  );
};
